import type { EntityId } from '@web-platform/shared-universal-types-utils/src/utils';

export const CITY_DRAWER_CITY_SELECTED = 'CITY_DRAWER_CITY_SELECTED' as const;
export const CITY_DRAWER_RESET = 'CITY_DRAWER_RESET' as const;

export type CityDrawerCitySelectedAction = {
  type: typeof CITY_DRAWER_CITY_SELECTED;
  payload: {
    cityId: EntityId;
    isDirect: boolean;
    postcardImageUrl?: string;
    destinationSkyCode: string;
    renderTargetId?: string;
  };
};

export type CityDrawerResetAction = {
  type: typeof CITY_DRAWER_RESET;
};
